<template>
  <div class="help">
    <h1>帮助中心</h1>
    <div class="h3">1 系统介绍</div>
    <span
      class="text"
    >在知识中心的总体框架下，中国工程科技研究机构与专家库自2015年开始建设。目前，系统已汇集专家成果数据一亿多条，专家名录900多万，上线了专家成果展示、合作者关系的分析、关键词分析、期刊分析等功能模块。同时，专家库还与国际标准名称识别符组织（ISNI）达成合作，为国内学者分配全球唯一学者标识ID。ISNI是国际标准名称识别码International Standard Name Identifier(ISO 27729)的缩写。主要为了避免不同身份的知识创造者使用相同名称而造成的混淆。目前，ISNI目前分配的数量已达1102万。</span>
    <div class="h3">2 系统使用说明</div>
    <img src="static/img/help/1.png" alt class="img" />
    <span class='legend'>图1 系统首页</span>
    <span class="text">专家库首页展示了系统现有资源数量实时统计，用户可以通过专家姓名、机构、关键词独立或组合检索查询。</span>
    <div class="h3">2.1 专家查询</div>
    <span class="text">通过专家姓名、机构、关键词字段检索专家后，在检索结果页面，将根据不同的搜索字段返回对应的查询结果页面。</span>
    <img src="static/img/help/2.png" alt class="img" />
    <span class='legend'>图2 按机构查询</span>
    <span class="text">当检索机构时，对于系统中收录的研究机构，将展示机构简介、机构的中外文成果的学科分布情况、机构的主要研究主题、该机构的合作情况以及该机构的专家信息。</span>
    <img src="static/img/help/3.png" alt class="img" />
    <img src="static/img/help/4.png" alt class="img" />
    <span class='legend'>图3 专家检索结果页</span>
    <span class="text">在专家检索结果页面可以点击右上方的页面布局按钮，按概要布局或详细列表方式进行展示。用户可以在专家列表中点击专家姓名或者头像打开该专家详情页。 </span>

    <div class="h3">2.2 专家详情</div>
    <img src="static/img/help/5.png" alt class="img" />
    <span class='legend'>图4 专家详情页面</span>
    <span class="text">专家详情页面内容包括：专家基础信息（姓名、所属机构、学科、个人简介、成果统计、成果图表）、专家学术分析、专家学术图谱、研究聚焦、专家成果列表。</span>
    <div class="h3">2.3 可视化统计</div>
    <span class="text">可视化统计页面对专家的研究情况进行了可视化的统计展现，具体包括：</span>
    <span class="text" style="font-weight:550">2.3.1 学术分析</span>
    <img src="static/img/help/6.png" alt class="img" />
    <span class="legend">图5 学术分析</span>
    <span class="text">学术分析依据专家的中文论文展示其学科分布的情况，可以了解专家研究的学科分布情况。</span>
    <span class="text" style="font-weight:550">2.3.2学术图谱</span>
    <span class="text">学术图谱对专家的中文期刊论文、SCI收录、EI收录、专利、图书、成果奖励和项目成果按年度进行了可视化的分析展现，有效的揭示了专家成果逐年分布情况。</span>
    <img src="static/img/help/7.png" alt class="img" />
    <span class="legend">图6 学术图谱</span>
    <span class="text" style="font-weight:550">2.3.3 研究聚焦</span>
    <img src="static/img/help/8.png" alt class="img" />
    <span class="legend">图7 研究聚焦</span>
    <span class="text">研究聚焦模块以时间线的方式按年度展现了专家的研究关键词，可了解该专家的研究变迁情况。</span>
    <span class="text" style="font-weight:550">2.3.4 成果详情</span>
    <img src="static/img/help/9.png" alt class="img" />
    <span class="legend">图8 成果详情</span>
    <span class="text">成果详情展示该专家的所有成果信息，可以通过成果类型、研究主题和相关学者，对专家成果进行筛选。同时，也可以按年份升序和降序对成果进行排序。</span>

    <div class="h3">2.4 关键词分析</div>
    <span class="text">关键词分析页面，利用专家库的学术大数据对检索关键词进行了九个维度的详细分析展现，为用户的研究提供深度的知识分析，具体包括：</span>
    <span class="text">相似关键词、关键词的英文翻译、中文关联关键词（来自中文论文）、英文关联关键词（来自外文论文）、围绕该关键词的专家图网、该关键词的历史热度、该关键词的学科、期刊和年度分布情况、该关键词研究的最早专家和涵盖该关键词的论文情况。</span>

    <img src="static/img/help/10.png" alt class="img" />
    <span class="legend">图9 关键词分析</span>
    <div class="h3">2.5   期刊分析</div>
    <span class="text">期刊分析页面对检索的期刊，从主要的学科分布情况、发文关键词、发文总量、发文机构排行和高发文作者排行，对检索期刊进行统计分析，帮助用户了解该期刊的学术趋势。</span>
    <img src="static/img/help/11.png" alt class="img" />
    <span class="legend">图10 期刊分析</span>
    <div class="h3">2.6 学术机构</div>
    <span
      class="text"
    >学术机构页面详细展示系统收录的学术研究机构信息，包括机构简介、机构成果概览、成果涉及的主要研究主题、合作机构及学科分布情况和主要成果产出学者。</span>
    <img src="static/img/help/13.png" alt class="img" />
    <span class="legend">图11 学术机构</span>
    <div class="h3">2.7 专家认领</div>
    <span
      class="text"
    >系统收录的专家完全来自对学术大数据分析提取，数据处理大部分通过计算机分析完成，结合小部分人工检查，脱漏在所难免。系统对于同名同姓的处理原则以机构为单位归并，即同一机构默认同名同姓为一人，待学者认领后区分。</span>
    <span class="text">用户在知识中心统一身份认证完成注册后，可在专家库可认领一位专家。认领入口为用户搜索的待认领专家的详情页面中专家姓名右侧的认领按钮，点击后进入认领。</span>

    <img src="static/img/help/14.png" alt class="img" />
    <span class="legend">图12 专家认领</span>
    <img src="static/img/help/15.png" alt class="img" />
    <span class="legend">图13 专家成果管理</span>
    <span
      class="text"
    >用户点击认领按钮完成有相关信息填写后，系统将自动跳转至个人中心页面，点击右侧的专家成果按钮，可以通过确认系统帮助用户筛选的专家成果或手动输入添加的方式进行成果补全，从而实现专家成果管理。对于已经认领的专家，专家详情页将显示已认领，并会展现已确认的成果。</span>
  </div>
</template>

<script>
export default {
  name: 'help',
  data () {
    return {}
  },
  mounted () {},
  methods: {}
}
</script>

<style lang="scss">
.help {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  min-width: 1200px;
  margin-bottom: 40px;
  padding:0 15%;
  h1 {
    margin: auto;
  }
  .h2 {
    margin-top: 40px;
    font-size: 1.7em;
  }
  .h3 {
    font-weight:600;
    margin-left: 2em;
    margin-top: 20px;
    font-size: 1.4em;
  }
  .legend{
    margin-top: 5px;
    text-align: center;
  }
  .text {
    margin-left: 2em;
    line-height: 40px;
    margin-top: 10px;
    font-size: 1.1em;
    text-indent: 2em;
  }
  .img {
    margin-left: 2em;
    margin-right: 2em;
    margin-top: 20px;
    width: 100%;
    height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/help.vue